import { render, staticRenderFns } from "./ReasonSelect.vue?vue&type=template&id=6a6c6533"
import script from "./ReasonSelect.vue?vue&type=script&lang=ts"
export * from "./ReasonSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports